import React, { useState } from 'react'

function UseFetch() {
    const [data,setData] = useState()

    const getData = async ()=>{
        try{

        const response = await fetch('https://djangoapp.arifsultani291.digital/test/')

        if(response.ok){
            const jsonData = await response.json();
            // console.log(jsonData)
            setData(jsonData)
        }else{
            const jsonData = await response.json();
            console.log(jsonData)
        }

        }catch(error){

        }
        
    }

  return {getData,data}
}

export default UseFetch
